import React from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { translateMessage } from "src/app/methods/translateMessage";
import { TextBoxWrapper } from "src/app/components/TextBoxWrapper/TextBoxWrapper";
import { CustomTextareaLabel } from "src/app/components/CustomTextarea/CustomTextarea";
import useGetProjectContentGuidelinesData from "src/app/project/hooks/useGetProjectContentGuidelinesData";

import "./ContentDataTab.scss";

function ContentDataTab({ setDescription, onDescriptionChange, intl }) {
  const { taskDetails } = useSelector((state) => state.taskReducer);

  const { contentGuidelinesContent } = useGetProjectContentGuidelinesData();

  const descriptionMetafield = taskDetails?.metadata?.find(
    (metafield) => metafield.key === "description",
  );

  const displayValue = descriptionMetafield?.manuallyEdited
    ? descriptionMetafield.value || ""
    : contentGuidelinesContent || "";

  return (
    <div className="content-data-tab">
      <CustomTextareaLabel
        htmlFor="task-brief"
        text={
          <IDHFormattedMessage
            id="ws_content_guidelines"
            defaultMessage="Content guidelines"
          />
        }
      />

      <TextBoxWrapper
        id="task-brief"
        className="brief-text-box"
        value={displayValue}
        onChange={setDescription}
        placeholder={translateMessage({
          intl,
          id: "ws_content_data_tab_placeholder",
          defaultMessage:
            "Here you can add content guidelines e.g.:&#10;&#8226;&nbsp;&nbsp;Content Concept&#10;&#8226;&nbsp;&nbsp;Talking Points&#10;&#8226;&nbsp;&nbsp;Photo Guidelines&#10;&#8226;&nbsp;&nbsp;Caption Guidelines&#10;&#8226;&nbsp;&nbsp;Post Instruction&#10;&#8226;&nbsp;&nbsp;Content Samples",
        })}
        onBlur={(newValue) => onDescriptionChange(newValue, displayValue)}
        enableEmoji
      />
    </div>
  );
}

export default injectIntl(ContentDataTab);
